import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';

import {useCurrentUserState} from 'app/current-user/api';
import {MainContentContainer} from 'app/general/structures/MainContentContainer';
import {SPPage} from 'app/general/structures/SPPage';
import {StyledStepsListDIV} from 'app/procedures/components/structures';
import {useQuiz, useQuizVersionDetail, useQuizVersions} from 'app/quizzes/api';
import {QuizPageSidebar} from 'app/quizzes/components/QuizPageSidebar';
import {ViewQuizMetadata} from 'app/quizzes/components/ViewQuizMetadata';
import {getQuizName} from 'app/utils/fallbacks';

type Props = {
  hashid: string;
  versionId: null | string;
  attemptId?: string;
  showAttempts?: boolean;
  children: React.ReactNode;
};

export function TakeQuizPage({
  hashid,
  versionId,
  showAttempts,
  children,
}: Props) {
  const {data: quiz} = useQuiz(hashid);
  const {data: quizVersion} = useQuizVersionDetail(
    versionId != null && quiz?.can_change ? {versionId} : skipToken
  );

  const {data: quizVersions} = useQuizVersions(
    quiz != null && quiz.can_change ? {quizId: quiz.id} : skipToken
  );

  const user = useCurrentUserState().data!;

  return (
    <SPPage
      pageTitle={quiz?.name}
      horizontalPadding={false}
      breadcrumbProps={{
        docName: getQuizName(quiz?.name),
        version: quizVersion,
      }}
      sidebar={
        quiz &&
        showAttempts && (
          <QuizPageSidebar
            quiz={quiz}
            versionId={versionId}
            versions={quizVersions?.results || []}
            version={quizVersion}
            userId={user.id}
            route={{props: {showAttempts}}}
          />
        )
      }
    >
      {quiz?.id && (
        <>
          <ViewQuizMetadata
            quiz={quiz}
            content={{
              name: quiz.name,
              description: quiz.description,
              pass_mark: quiz.pass_mark,
              duration: quiz.duration,
              content: quizVersion?.content || null,
            }}
          />
        </>
      )}

      <StyledStepsListDIV className="js-document-body container pt-0">
        <MainContentContainer>{children}</MainContentContainer>
      </StyledStepsListDIV>
    </SPPage>
  );
}
